import { render } from "./PrintWidget.vue?vue&type=template&id=0415f687"
import script from "./PrintWidget.vue?vue&type=script&lang=js"
export * from "./PrintWidget.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__